import React, { useEffect, useState } from "react";

const SvgRuler = (activeSlide) => {
  const [value, setValue] = useState(activeSlide);

  useEffect(() => {
    setValue(activeSlide.activeSlide);
  }, [activeSlide]);
  return (
    <svg
      width="279"
      height="81"
      viewBox="0 0 279 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="21.5"
        width="278"
        height="59"
        rx="3.5"
        fill="#0F0F0F"
        stroke="#929292"
      />
      <path
        d="M9.66406 8.23438L11.25 4.3125H12.4297V15H11.0859L11.1719 7.27344L11.1328 7.24219L9.78906 10.7578H9.53906L8.19531 7.24219L8.15625 7.27344L8.24219 15H6.89844V4.3125H8.07812L9.66406 8.23438ZM17.1981 15.1953C16.5158 15.1953 15.9742 14.8646 15.5731 14.2031C15.1773 13.5365 14.9794 12.6224 14.9794 11.4609C14.9794 10.2995 15.1773 9.38542 15.5731 8.71875C15.9742 8.05208 16.5158 7.71875 17.1981 7.71875C17.8804 7.71875 18.4221 8.05208 18.8231 8.71875C19.2242 9.38542 19.4247 10.2995 19.4247 11.4609C19.4247 12.6224 19.2242 13.5365 18.8231 14.2031C18.4221 14.8646 17.8804 15.1953 17.1981 15.1953ZM17.1825 8.90625C16.5627 8.90625 16.2528 9.75781 16.2528 11.4609C16.2528 13.1589 16.5731 14.0078 17.2137 14.0078C17.8335 14.0078 18.1434 13.1589 18.1434 11.4609C18.1434 9.75781 17.8231 8.90625 17.1825 8.90625ZM22.365 5.60938C22.1671 5.60938 21.9978 5.53906 21.8572 5.39844C21.7166 5.25781 21.6462 5.08854 21.6462 4.89062C21.6462 4.6875 21.7166 4.51823 21.8572 4.38281C21.9978 4.24219 22.1671 4.17188 22.365 4.17188C22.5629 4.17188 22.7322 4.24219 22.8728 4.38281C23.0134 4.51823 23.0837 4.6875 23.0837 4.89062C23.0837 5.08854 23.0134 5.25781 22.8728 5.39844C22.7322 5.53906 22.5629 5.60938 22.365 5.60938ZM21.0056 18.8203V17.625C21.2921 17.5781 21.4926 17.4479 21.6072 17.2344C21.727 17.0208 21.7869 16.6224 21.7869 16.0391V7.91406H23.0369V15.5156C23.0369 16.3542 22.99 16.9557 22.8962 17.3203C22.8025 17.6849 22.5968 18.013 22.2791 18.3047C21.9614 18.5964 21.5369 18.7682 21.0056 18.8203Z"
        fill="white"
      />
      <path
        d="M6.10748 70.1143C5.42193 70.1143 4.86334 69.7186 4.4317 68.9272C4.00006 68.1317 3.78424 67.042 3.78424 65.6582C3.78424 64.3506 3.98736 63.2821 4.39361 62.4526C4.8041 61.619 5.37538 61.2021 6.10748 61.2021C6.81842 61.2021 7.38336 61.6169 7.80231 62.4463C8.22548 63.2757 8.43707 64.3464 8.43707 65.6582C8.43707 67.0547 8.2149 68.1465 7.77057 68.9336C7.32623 69.7207 6.77187 70.1143 6.10748 70.1143ZM6.09479 62.2368C5.72662 62.2368 5.44309 62.5415 5.2442 63.1509C5.04954 63.756 4.95221 64.5918 4.95221 65.6582C4.95221 66.7627 5.05377 67.609 5.2569 68.1973C5.46002 68.7855 5.74778 69.0796 6.12018 69.0796C6.47565 69.0796 6.75494 68.7791 6.95807 68.1782C7.16542 67.5773 7.2691 66.7373 7.2691 65.6582C7.2691 64.5622 7.16542 63.7179 6.95807 63.1255C6.75071 62.533 6.46295 62.2368 6.09479 62.2368ZM10.5531 70V61.3164H11.4862C12.231 61.3164 12.7981 61.5365 13.1874 61.9766C13.581 62.4124 13.7777 62.9943 13.7777 63.7222C13.7777 64.5474 13.4773 65.1673 12.8764 65.582C13.3419 65.9121 13.7375 66.7902 14.0634 68.2163L14.4633 70H13.2953L12.9589 68.502C12.7177 67.4525 12.5082 66.786 12.3305 66.5024C12.1527 66.2147 11.9327 66.0856 11.6703 66.1152V70H10.5531ZM11.6703 65.0742H11.7211C12.3474 65.0742 12.6605 64.6362 12.6605 63.7603C12.6605 62.8293 12.3305 62.3617 11.6703 62.3574V65.0742ZM16.1731 70V61.3164H17.2903V70H16.1731ZM23.7672 65.3345V69.6001C23.2424 69.9429 22.7304 70.1143 22.231 70.1143C21.3508 70.1143 20.6547 69.7228 20.1427 68.9399C19.6306 68.1571 19.3746 67.0674 19.3746 65.6709C19.3746 64.2956 19.6221 63.208 20.1173 62.4082C20.6124 61.6042 21.2747 61.2021 22.1041 61.2021C22.6034 61.2021 23.1578 61.4095 23.7672 61.8242V63.0176C23.1451 62.4548 22.6077 62.1733 22.1549 62.1733C21.0461 62.1733 20.4918 63.3392 20.4918 65.6709C20.4918 67.9434 21.08 69.0796 22.2564 69.0796C22.3538 69.0796 22.4849 69.0648 22.65 69.0352V66.3755H21.8819V65.3345H23.7672ZM25.9911 70V61.3164H27.1083V70H25.9911ZM29.5164 70V61.3164H30.4241L32.3474 66.6738H32.3728V61.3164H33.4011V70H32.4934L30.5701 64.5918H30.5447V70H29.5164ZM35.1681 70L36.8058 61.2656H37.9674L39.5924 70H38.5133L38.2022 68.0767H36.5899L36.2472 70H35.1681ZM36.755 67.0356H38.0055L37.3961 63.3984H37.3644L36.755 67.0356ZM41.3657 70V61.3164H42.4828V68.959H44.6284V70H41.3657Z"
        fill={`${value === 1 ? "#FFFF00" : "white"}`}
      />
      <path
        d="M55.0103 70.1143C54.3248 70.1143 53.7662 69.7186 53.3345 68.9272C52.9029 68.1317 52.6871 67.042 52.6871 65.6582C52.6871 64.3506 52.8902 63.2821 53.2964 62.4526C53.7069 61.619 54.2782 61.2021 55.0103 61.2021C55.7213 61.2021 56.2862 61.6169 56.7051 62.4463C57.1283 63.2757 57.3399 64.3464 57.3399 65.6582C57.3399 67.0547 57.1177 68.1465 56.6734 68.9336C56.2291 69.7207 55.6747 70.1143 55.0103 70.1143ZM54.9976 62.2368C54.6295 62.2368 54.3459 62.5415 54.147 63.1509C53.9524 63.756 53.855 64.5918 53.855 65.6582C53.855 66.7627 53.9566 67.609 54.1597 68.1973C54.3629 68.7855 54.6506 69.0796 55.023 69.0796C55.3785 69.0796 55.6578 68.7791 55.8609 68.1782C56.0683 67.5773 56.1719 66.7373 56.1719 65.6582C56.1719 64.5622 56.0683 63.7179 55.8609 63.1255C55.6535 62.533 55.3658 62.2368 54.9976 62.2368ZM59.4433 70V61.3164H62.1474V62.3574H60.5604V64.9409H62.0395V65.9819H60.5604V70H59.4433ZM64.5808 70V61.3164H67.2849V62.3574H65.698V64.9409H67.177V65.9819H65.698V70H64.5808ZM69.6929 70V61.3164H70.8101V70H69.6929ZM76.5317 68.4512V69.6255C76.1127 69.9513 75.6705 70.1143 75.205 70.1143C74.4602 70.1143 73.8847 69.7334 73.4784 68.9717C73.0722 68.21 72.8691 67.1224 72.8691 65.709C72.8691 64.2956 73.0722 63.1911 73.4784 62.3955C73.8889 61.5999 74.4729 61.2021 75.2304 61.2021C75.5943 61.2021 75.9942 61.3524 76.4301 61.6528V62.7827C76.0577 62.4188 75.6853 62.2368 75.3129 62.2368C74.8643 62.2368 74.5385 62.5013 74.3354 63.0303C74.1365 63.555 74.037 64.431 74.037 65.6582C74.037 66.8727 74.1386 67.7466 74.3417 68.2798C74.5448 68.813 74.8813 69.0796 75.351 69.0796C75.6726 69.0796 76.0662 68.8701 76.5317 68.4512ZM78.4192 70V61.3164H79.5364V70H78.4192ZM81.2652 70L82.9029 61.2656H84.0646L85.6896 70H84.6105L84.2994 68.0767H82.6871L82.3443 70H81.2652ZM82.8521 67.0356H84.1026L83.4933 63.3984H83.4615L82.8521 67.0356ZM87.4628 70V61.3164H88.58V68.959H90.7255V70H87.4628Z"
        fill={`${value === 2 ? "#FFFF00" : "white"}`}
      />
      <path
        d="M102.982 70V61.3164H105.686V62.3574H104.099V64.9409H105.578V65.9819H104.099V70H102.982ZM106.932 70L108.57 61.2656H109.732L111.357 70H110.278L109.967 68.0767H108.354L108.011 70H106.932ZM108.519 67.0356H109.77L109.16 63.3984H109.129L108.519 67.0356ZM115.339 64.5029L116.628 61.3164H117.586V70H116.494L116.564 63.7222L116.532 63.6968L115.441 66.5532H115.237L114.146 63.6968L114.114 63.7222L114.184 70H113.092V61.3164H114.05L115.339 64.5029ZM119.956 70V61.3164H121.073V70H119.956ZM123.481 70V61.3164H124.598V68.959H126.744V70H123.481ZM129.152 70V66.0327L127.787 61.3164H128.936L129.685 64.7251H129.711L130.504 61.3164H131.666L130.275 66.0327V70H129.152Z"
        fill={`${value === 3 ? "#FFFF00" : "white"}`}
      />
      <path
        d="M151.27 64.8774H153.802V62.3447H154.882V64.8774H157.414V65.9565H154.882V68.4893H153.802V65.9565H151.27V64.8774ZM161.396 70V61.3164H162.514V70H161.396ZM165.842 69.8984V68.7939C166.202 68.9759 166.523 69.0669 166.807 69.0669C167.15 69.0669 167.425 68.9251 167.632 68.6416C167.844 68.3538 167.95 67.9709 167.95 67.4927C167.95 66.5786 167.573 66.0623 166.82 65.9438V64.8394C167.505 64.7336 167.848 64.3083 167.848 63.5635C167.848 63.1742 167.753 62.8652 167.562 62.6367C167.376 62.4082 167.124 62.2939 166.807 62.2939C166.57 62.2939 166.314 62.3743 166.039 62.5352V61.4434C166.344 61.2995 166.678 61.2275 167.042 61.2275C167.596 61.2275 168.06 61.4328 168.432 61.8433C168.804 62.2537 168.991 62.7679 168.991 63.3857C168.991 64.2617 168.553 64.9198 167.677 65.3599C168.62 65.7069 169.092 66.4517 169.092 67.5942C169.092 68.3052 168.885 68.9103 168.47 69.4097C168.055 69.909 167.552 70.1587 166.959 70.1587C166.655 70.1587 166.282 70.0719 165.842 69.8984Z"
        fill={`${value === 4 ? "#FFFF00" : "white"}`}
      />
      <path
        d="M202.165 68.4512V69.6255C201.746 69.9513 201.304 70.1143 200.838 70.1143C200.093 70.1143 199.518 69.7334 199.112 68.9717C198.705 68.21 198.502 67.1224 198.502 65.709C198.502 64.2956 198.705 63.1911 199.112 62.3955C199.522 61.5999 200.106 61.2021 200.864 61.2021C201.227 61.2021 201.627 61.3524 202.063 61.6528V62.7827C201.691 62.4188 201.318 62.2368 200.946 62.2368C200.497 62.2368 200.172 62.5013 199.968 63.0303C199.77 63.555 199.67 64.431 199.67 65.6582C199.67 66.8727 199.772 67.7466 199.975 68.2798C200.178 68.813 200.514 69.0796 200.984 69.0796C201.306 69.0796 201.699 68.8701 202.165 68.4512ZM204.09 70V61.3164H205.208V65.1377H206.858V61.3164H207.975V70H206.858V66.1787H205.208V70H204.09ZM209.742 70L211.38 61.2656H212.541L214.166 70H213.087L212.776 68.0767H211.164L210.821 70H209.742ZM211.329 67.0356H212.58L211.97 63.3984H211.938L211.329 67.0356ZM216.308 70V62.3574H214.969V61.3164H218.764V62.3574H217.431V70H216.308Z"
        fill={`${value === 5 ? "#FFFF00" : "white"}`}
      />
      <path
        d="M237.964 70V61.3164H239.145C239.944 61.3164 240.579 61.5301 241.049 61.9575C241.523 62.3849 241.76 62.9731 241.76 63.7222C241.76 64.4881 241.542 65.0911 241.106 65.5312C240.67 65.9714 240.073 66.1914 239.316 66.1914H239.081V70H237.964ZM239.081 65.1504H239.278C240.188 65.1504 240.643 64.6532 240.643 63.6587C240.643 62.7658 240.122 62.332 239.081 62.3574V65.1504ZM243.711 70V61.3164H244.644C245.389 61.3164 245.956 61.5365 246.345 61.9766C246.739 62.4124 246.935 62.9943 246.935 63.7222C246.935 64.5474 246.635 65.1673 246.034 65.582C246.499 65.9121 246.895 66.7902 247.221 68.2163L247.621 70H246.453L246.117 68.502C245.875 67.4525 245.666 66.786 245.488 66.5024C245.31 66.2147 245.09 66.0856 244.828 66.1152V70H243.711ZM244.828 65.0742H244.879C245.505 65.0742 245.818 64.6362 245.818 63.7603C245.818 62.8293 245.488 62.3617 244.828 62.3574V65.0742ZM249.331 70V61.3164H250.448V70H249.331ZM253.802 70.1143L252.202 61.3164H253.376L254.195 67.1689L255.001 61.3164H256.169L254.57 70.1143H253.802ZM257.022 70L258.66 61.2656H259.822L261.447 70H260.368L260.056 68.0767H258.444L258.101 70H257.022ZM258.609 67.0356H259.86L259.25 63.3984H259.219L258.609 67.0356ZM263.588 70V62.3574H262.249V61.3164H266.045V62.3574H264.712V70H263.588ZM267.862 70V61.3164H270.954V62.3574H268.98V64.9536H270.789V65.9946H268.98V68.959H271.062V70H267.862Z"
        fill={`${value === 6 ? "#FFFF00" : "white"}`}
      />
      <path
        d="M25 33L25 53"
        stroke="#B3B3B3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M29.5801 33L29.5801 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M34.1602 33L34.1602 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M38.7402 33L38.7402 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M43.3203 33L43.3203 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M47.9004 33L47.9004 48"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M52.4805 33L52.4805 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M57.0596 33L57.0596 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M61.6396 33L61.6396 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M66.2197 33L66.2197 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M70.7998 33L70.7998 53"
        stroke="#B3B3B3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M75.3799 33L75.3799 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path d="M79.96 33L79.96 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M84.54 33L84.54 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path
        d="M89.1201 33L89.1201 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M93.7002 33L93.7002 48"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path
        d="M98.2803 33L98.2803 43"
        stroke="#B3B3B3"
        strokeLinecap="round"
      />
      <path d="M102.86 33L102.86 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M107.44 33L107.44 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M112.02 33L112.02 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path
        d="M116.6 33L116.6 53"
        stroke="#B3B3B3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M121.18 33L121.18 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M125.76 33L125.76 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M130.34 33L130.34 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M134.92 33L134.92 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M139.5 33L139.5 48" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M144.08 33L144.08 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M148.66 33L148.66 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M153.24 33L153.24 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M157.82 33L157.82 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path
        d="M162.4 33L162.4 53"
        stroke="#B3B3B3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M166.98 33L166.98 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M171.56 33L171.56 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M176.14 33L176.14 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M180.72 33L180.72 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M185.3 33L185.3 48" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M189.88 33L189.88 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M194.46 33L194.46 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M199.04 33L199.04 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M203.62 33L203.62 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path
        d="M208.2 33L208.2 53"
        stroke="#B3B3B3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M212.78 33L212.78 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M226.52 33L226.52 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M240.26 33L240.26 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M217.36 33L217.36 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M231.1 33L231.1 48" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M244.84 33L244.84 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M221.94 33L221.94 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M235.68 33L235.68 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path d="M249.42 33L249.42 43" stroke="#B3B3B3" strokeLinecap="round" />
      <path
        d="M254 33L254 53"
        stroke="#B3B3B3"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SvgRuler;
